import { render, staticRenderFns } from "./AddRule.vue?vue&type=template&id=59954b66"
import script from "./AddRule.ts?vue&type=script&lang=ts&external"
export * from "./AddRule.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports